import { useMemo, useState } from 'react';

export function useSearchSort(rows: any[]) {
  const [query, setQuery] = useState('');
  const [sortKey, setSortKey] = useState<string | null>(null);
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');

  const toggleSort = (k: string) =>
    sortKey === k
      ? setSortDir(d => (d === 'asc' ? 'desc' : 'asc'))
      : (setSortKey(k), setSortDir('asc'));

  const view = useMemo(() => {
    let r = rows || [];
    const q = query.trim().toLowerCase();
    if (q) r = r.filter(row => Object.values(row).some(v => String(v ?? '').toLowerCase().includes(q)));
    if (sortKey) {
      r = [...r].sort((a, b) => {
        const av = a?.[sortKey], bv = b?.[sortKey];
        const an = Number(av), bn = Number(bv);
        const numeric = av !== '' && bv !== '' && !isNaN(an) && !isNaN(bn);
        const cmp = numeric ? an - bn : String(av ?? '').localeCompare(String(bv ?? ''));
        return sortDir === 'asc' ? cmp : -cmp;
      });
    }
    return r;
  }, [rows, query, sortKey, sortDir]);

  return { view, query, setQuery, sortKey, sortDir, toggleSort };
}
